import {observable} from 'mobx';

import {CtLocaleContent} from './ct-locale-content';
import {CtLocaleKeyHints} from './ct-locale-hints';
import {CtLocaleCategory} from './ct-locale-category';

import {construct, createArrayInstance, createInstance, ModelProperties} from '../utils';

export class CtLocaleKey {
    @observable id!: number;

    @observable name!: string;

    @observable whitespaces!: boolean;

    @observable charLimit!: number;

    @observable enabled!: boolean;

    @observable categoryId!: number;

    @observable hints?: CtLocaleKeyHints[];

    @observable content?: CtLocaleContent[];

    @observable category?: CtLocaleCategory;

    @observable createdAt!: Date;

    @observable updatedAt!: Date;

    constructor(key?: ModelProperties<CtLocaleKey>) {
        if (key) {
            construct(this, key);
            this.hints = createArrayInstance(CtLocaleKeyHints, key.hints);
            this.content = createArrayInstance(CtLocaleContent, key.content);
            this.category = createInstance(CtLocaleCategory, key.category);
        }
    }
}